/* global Homie */
export default {
	template: '#process-init',	
	data: data,
	mounted: mounted,
	methods: {
		isLogged: isLogged,
    showPreRegistration: showPreRegistration,
    toggle: toggle
	}
}

function data(){
  return {
    tenant: {isOpen: false, text: 'Leer más'},
    payment: {isOpen: false, text: 'Leer más'},
    security: {isOpen: false, text: 'Leer más'},
    lists: {isOpen: false, text: 'Leer más'},
    show_contry_codes: false,
    mobile_phone_backup: '',
    user: {
      name: '',
      last_name: '.',
      second_last_name: '.',
      email: '',
      mobile_phone: '',
      bypass_password: true
    },
    country_code: '52',
    from_axios: true,
    error: false,
    role: 'owner'
  }
}

function mounted(){
  if (this.isLogged()){
    this.user.name = Homie.user.name;
    this.user.last_name = Homie.user.last_name;
    this.user.second_last_name = Homie.user.second_last_name;
    this.user.email = Homie.user.email;
  }
}

function isLogged(){
  return Homie.is_logged;
}

function showPreRegistration(){
  if (Homie.is_logged && Homie.user.mobile_phone) {
    return this.$router.push({name: 'auth.term'});
  }
  this.$router.push({ name: 'pre_registration' });
}

function toggle(feature){
  feature.isOpen = !feature.isOpen;
  feature.text = feature.isOpen ? '¡Entendido!' : 'Leer más';
}